import { useCallback, useEffect, useState } from 'react'
import ClassService from '~services/class'
import { getDoc } from '~providers/firebase'
import { DocumentData, FirestoreError } from 'firebase/firestore'
import useIsMounted from 'ismounted'
import { FirebaseError } from 'firebase/app'

type UseClassReturn = [DocumentData | undefined, FirebaseError | undefined]

const useClass = (classId: string): UseClassReturn => {
  const [value, setValue] = useState<UseClassReturn>([undefined, undefined])
  const isMounted = useIsMounted()

  const load = useCallback(async () => {
    try {
      const doc = await getDoc(ClassService.getClass(classId))
      if (isMounted) {
        setValue([doc.data(), undefined])
      }
    } catch (error) {
      if (isMounted) {
        setValue([undefined, error as FirestoreError])
      }
    }
  }, [classId])

  useEffect(() => {
    load()
  }, [load])

  return value
}

export default useClass
